import { Resource, Observation } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'category', title: 'Category' },
  { code: 'description', title: 'Description' },
  { code: 'date', title: 'Date' },
  { code: 'comment', title: 'Comment' },
  { code: 'doctor', title: 'Doctor' },
]

const renderColumn = (resource: Observation, itemCode: string): string => {
  switch (itemCode) {
    case 'category':
      return resource.code?.coding?.[0]?.display || resource.code?.text || '—'
    case 'description':
      if (resource.valueString) return resource.valueString
      if (resource.valueCodeableConcept)
        return (
          resource.valueCodeableConcept.text ||
          resource.valueCodeableConcept.coding?.[0]?.display ||
          resource.valueCodeableConcept.coding?.[0]?.code ||
          ''
        )
      if (resource.valueQuantity) return resource.valueQuantity.value?.toString() || ''
      if (resource.valueBoolean !== undefined) return resource.valueBoolean ? 'Yes' : 'No'
      return ''
    case 'date': {
      const date =
        resource.effectiveDateTime ||
        (resource.effectivePeriod &&
          resource.effectivePeriod.start + ' — ' + resource.effectivePeriod.end) ||
        resource.issued ||
        ''
      return date ? formatDateTime(date, '-', true) : '-'
    }
    case 'comment':
      return resource.note?.map((n) => n.text).join('; ') || ''
    case 'doctor':
      if (resource.performer && resource.performer.length > 0)
        return resource.performer.map((p) => p.display).join(', ')
      return ''
    default:
      return ''
  }
}

export function SocialHistory({ resource }: Props) {
  const observation = resource as Observation

  if (!observation) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="py-1 text-sm font-bold text-[#7D7987]">{item.title}:</td>
              <td className="px-[8px] py-1 text-base text-sm">
                <div>{renderColumn(observation, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
